import $ from "jquery"
import './../scss/style.scss';
//  import Bootstrap 
require('bootstrap');

import { WCAG } from "rytm-wcag";
import { initCommon } from './shared/common'
import { initCookies } from './shared/cookies'
import { loadingSequence } from "./loading";
import { initContactLoader } from "./shared/contact-loader";

$(() => {
  // # on ready
  WCAG.init()
  initCommon()
  initCookies()
  initContactLoader()
  // loading sequence
  loadingSequence()
});
